module.exports = __webpack_public_path__ + "static/Equipe_Remota-b39b03b0749677a61fc9d9ecc3aa9106.mp4";